import { useRef, useState } from "react";
import { Play } from "lucide-react";

export default function Trailer({ testid }) {
  const [playing, setPlaying] = useState(false);
  const ref = useRef(null);

  const start = () => {
    setPlaying(true);
    try {
      ref.current?.play();
    } catch {}
  };

  return (
    <div className="relative mx-auto w-full max-w-[340px]" data-testid={testid}>
      <div className="clip-frame relative overflow-hidden shadow-[0_50px_90px_-20px_rgba(0,0,0,0.85)] ring-1 ring-white/10">
        <video
          ref={ref}
          src="/media/isabella_books_reel.mp4"
          poster="/img/reel-poster.jpg"
          controls={playing}
          preload="none"
          playsInline
          onPlay={() => setPlaying(true)}
          onEnded={() => setPlaying(true)}
          className="block h-auto w-full"
        />
        {!playing && (
          <button
            onClick={start}
            aria-label="Play the book trailer"
            data-testid={`${testid}-play`}
            className="absolute inset-0 flex items-center justify-center bg-[#070A11]/35 transition-colors duration-300 hover:bg-[#070A11]/15"
          >
            <span className="flex h-20 w-20 items-center justify-center rounded-full bg-cyanx text-void shadow-[0_0_60px_rgba(0,240,255,0.5)] transition-transform duration-300 hover:scale-110">
              <Play size={30} fill="currentColor" />
            </span>
          </button>
        )}
      </div>
      <div aria-hidden className="mx-auto -mt-2 h-14 w-3/4 rounded-full bg-cyanx/15 blur-2xl" />
    </div>
  );
}
